import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { STAGE_META } from "@/utils/quoteStages";

const label = (h) => {
  if (h.action === "created") return `Logged as ${STAGE_META[h.to]?.label || h.to}`;
  if (h.action === "stage") return `${STAGE_META[h.from]?.label || h.from || "—"} → ${STAGE_META[h.to]?.label || h.to}`;
  if (h.action === "payment") return "Payment recorded";
  if (h.action === "payment_removed") return "Payment removed";
  return "Details edited";
};

export const QuoteHistory = ({ quote }) => {
  const [open, setOpen] = useState(false);
  const items = [...(quote.history || [])].reverse();
  if (!items.length) return null;
  return (
    <div>
      <button type="button" onClick={() => setOpen(!open)} className="flex items-center gap-1 text-[10px] font-medium text-slate-500 hover:text-slate-800" data-testid={`quote-history-toggle-${quote.id}`}>
        <ChevronDown size={11} className={`transition-transform ${open ? "rotate-180" : ""}`} /> History ({items.length})
      </button>
      {open && (
        <ul className="mt-1 space-y-0.5 border-l-2 border-slate-100 pl-2" data-testid={`quote-history-${quote.id}`}>
          {items.map((h, i) => (
            <li key={i} className="text-[10px] text-slate-600">
              <span className="font-medium text-slate-800">{label(h)}</span>
              {h.detail && <span className="text-muted-foreground"> · {h.detail}</span>}
              <span className="text-muted-foreground"> · {h.by} · {new Date(h.at).toLocaleString("en-GB", { dateStyle: "short", timeStyle: "short" })}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
